import * as React from "react";
import PropTypes from "prop-types";
import {
  Eye16Filled,
  Certificate16Regular,
  ListBar16Filled,
  TableSimple16Regular,
  MoreHorizontal16Regular,
  MoreVertical16Filled,
} from "@fluentui/react-icons";
import {
  Label,
  Menu,
  MenuButton,
  MenuItem,
  MenuItemLink,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Tooltip,
  Image,
  Text,
  Link,
  tokens,
  makeStyles,
  Card,
  CardFooter,
  CardHeader,
  CardPreview,
  Button,
  typographyStyles,
} from "@fluentui/react-components";

import { courierAbbr, courierLink, statusAbbr } from "../utilities/orders";

const useStyles = makeStyles({
  component: {
    paddingRight: tokens.spacingHorizontalM,
  },
  tools: {
    marginBottom: tokens.spacingVerticalM,
    textAlign: "right",
  },
  cards: {
    marginBottom: tokens.spacingVerticalM,
  },
  card: {
    marginBottom: tokens.spacingVerticalM,
  },
  cardPreview: {
    paddingLeft: tokens.spacingVerticalM,
    paddingRight: tokens.spacingVerticalM,
  },
  toolsButton: {
    marginLeft: tokens.spacingHorizontalSNudge,
  },
  label: {
    display: "block",
    color: tokens.colorBrandStroke1,
    fontWeight: tokens.fontWeightBold,
  },
  text: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    marginRight: tokens.spacingHorizontalSNudge,
  },
  textBlock: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    display: "block",
  },
  textLink: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
  },
  textLinkStrong: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightBold,
  },
});

const Orders = (props) => {
  const { data, domain, loading } = props;
  const styles = useStyles();

  return (
    <section className={styles.component}>
      {loading == false && data !== null ? (
        data && data.length ? (
          <div className={styles.cards}>
            {data.map((order) => {
              return (
                <Card className={styles.card} key={order.Order.id}>
                  <CardHeader
                    header={
                      <Link
                        href={`${domain}/admin/orders/view/${order.Order.id}`}
                        target="_blank"
                        className={styles.textLinkStrong}
                      >
                        #{order.Order.id}
                      </Link>
                    }
                    action={
                      <div>
                        <Text className={styles.text}>{new Date(order.Order.created).toLocaleString()}</Text>
                        <Menu>
                          <MenuTrigger disableButtonEnhancement>
                            <MenuButton icon={<MoreVertical16Filled />} size="small" appearance="transparent" />
                          </MenuTrigger>
                          <MenuPopover>
                            <MenuList>
                              <MenuItemLink
                                icon={<Eye16Filled />}
                                href={`${domain}/admin/orders/view/${order.Order.id}`}
                                target="_blank"
                              >
                                View
                              </MenuItemLink>
                              <MenuItemLink
                                icon={<Certificate16Regular />}
                                href={`${domain}/admin/warranties/add/${order.Order.id}`}
                                target="_blank"
                              >
                                Warranty Request
                              </MenuItemLink>
                            </MenuList>
                          </MenuPopover>
                        </Menu>
                      </div>
                    }
                  />
                  <CardPreview className={styles.cardPreview}>
                    {order.Purchase.map((purchase) => {
                      return (
                        <Text className={styles.text} key={purchase.id}>
                          {purchase.quantity} x {purchase.product_title}
                        </Text>
                      );
                    })}
                  </CardPreview>
                  <CardFooter>
                    <div>
                      <Label size="small" weight="semibold" className={styles.label}>
                        Status
                      </Label>
                      <Text className={styles.text}>{statusAbbr(order.Status.id)}</Text>
                    </div>
                    {order.Order.courier && (
                      <div>
                        <Label size="small" weight="semibold" className={styles.label}>
                          Courier
                        </Label>
                        <Text className={styles.text}>{courierAbbr(order.Order.courier)}</Text>
                      </div>
                    )}
                    {order.Order.courier_tracking && (
                      <div>
                        <Label size="small" weight="semibold" className={styles.label}>
                          Tracking
                        </Label>
                        <Link href={`${courierLink(order.Order.courier, order.Order.courier_tracking)}`}>
                          {order.Order.courier_tracking}
                        </Link>
                      </div>
                    )}
                  </CardFooter>
                </Card>
              );
            })}
          </div>
        ) : (
          <Text className={styles.text}>No order found</Text>
        )
      ) : (
        <Text>Loading...</Text>
      )}
    </section>
  );
};

Orders.propTypes = {
  query: PropTypes.object,
};

export default Orders;
